import React from 'react';
import PropTypes from 'prop-types';

import styles from './ToggleSwitch.module.css';

const ToggleSwitch = ({
  id,
  name,
  checked,
  disabled,
  labelOff,
  labelOn,
  onChange,
  onClickDisabled,
}) => {
  const icon = checked ? 'far fa-unlock-alt' : 'far fa-lock-alt';
  const handleClick = () => {
    if (disabled) onClickDisabled();
  };
  const handleChange = (e) => {
    if (!disabled) onChange(e);
  };

  return (
    <div className={styles.container}>
      <input
        type="checkbox"
        className={styles.checkbox}
        name={name}
        id={id}
        checked={checked}
        onClick={handleClick}
        onChange={handleChange}
      />
      <label className={styles.label} htmlFor={id}>
        <span
          className={`${styles.inner} ${disabled ? styles.disabled : ''}`}
          data-on={labelOn}
          data-off={labelOff}
        />
        <span className={`${styles.switch} ${disabled ? styles.disabled : ''}`}>
          <i className={icon} />
        </span>
      </label>
    </div>
  );
};

ToggleSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  labelOff: PropTypes.string,
  labelOn: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClickDisabled: PropTypes.func.isRequired,
};

ToggleSwitch.defaultProps = {
  name: null,
  disabled: false,
  labelOff: null,
  labelOn: null,
};

export default ToggleSwitch;
